/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_MondayInputs */

const fr_week_session_day_names_monday = /** @type {(inputs: Week_Session_Day_Names_MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lun`)
};

/**

* @param {Week_Session_Day_Names_MondayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_monday = /** @type {((inputs?: Week_Session_Day_Names_MondayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_MondayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_monday(inputs)
});